import moment from "moment";
import _ from "lodash";
import { ConsultantFilterState } from "../utils/consultant-filter-state";

const datePaths = [
  "availability.from",
  "availability.to",
  "lastContact.dates.from",
  "lastContact.dates.to",
  "nextContact.from",
  "nextContact.to",
  "bookingStatus.bookingStatusDate",
  "bookingStatus.bookingStatusDateEnd"
];

export function parseSearchProfileFilters(
  filters: Partial<ConsultantFilterState>
): Partial<ConsultantFilterState> {
  const parsedFilters = { ...filters };

  for (const path of datePaths) {
    const value = _.get(parsedFilters, path);

    if (value) {
      _.set(parsedFilters, path, moment(value).toDate());
    }
  }

  return parsedFilters;
}
